// ABOUTME: Composes the chat reply for a publish-now action from the server's
// actual response (#2460). "Publish now" does not publish now: inside the
// grace window the backend returns {status: 'scheduled', scheduled_at:
// now+window}, so no surface may describe it as immediate or irreversible
// while it is still cancelable. The reply is therefore derived from the response — never a
// hardcoded "Publishing now.", and never a hardcoded window length (the
// setting is the server's to change; the timestamp it returned already
// reflects it).
import type { ContentDraft } from '@/types'

export interface PublishDraftResult {
  status: ContentDraft['status']
  scheduled_at: string | null
}

export function publishNowReply({ status, scheduled_at }: PublishDraftResult): string {
  if (status === 'scheduled') {
    const at = scheduled_at ? new Date(scheduled_at) : null
    const when =
      at && !Number.isNaN(at.getTime())
        ? at.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
        : null
    return when
      ? `Queued — it goes out at ${when}, and you can still cancel it until then. Nothing has been published yet.`
      : 'Queued — it goes out shortly, and you can still cancel it until then. Nothing has been published yet.'
  }
  // Grace window off: the publish really did dispatch straight away.
  return 'Publishing now.'
}
